import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent implements OnInit {
  @Input() tag: any;
  @Input() label: string = '';
  @Input() tagColor: string = '#919796';
  @Input() textColor: string = '#ffffff';
  @Input() isDeletable: boolean = false;
  @Input() stopPropagationOnDelete: boolean = false;
  @Input() fontSize: number = 12; // [8, 9, 10, 12, 14, 16];
  @Input() textTruncate: boolean = true;
  @Input() tagHeight: number = 0;
  @Input() id: string = '';
  @Input() itemType: string = '';

  @Output() appDelete = new EventEmitter<any>();

  nonRemoveAbleTagsType: string[] = ['salesCode', 'partWarranties', 'warrantyNo'];
  // ALP-20816 - Removed Sublet From System Specific tags to allow deletion
  systemSpecificTags = ['MOTOR', 'PartsTech', 'Core', 'Returned', 'Store', 'Return', 'Pending', 'Removed', 'Stored', 'Nexpart', 'RepairLink', 'Mitchell1', 'TireHub', 'TireConnect', 'Refunded', 'SpeedDial'];
  constructor() {}

  ngOnInit() {
    if(this.tag && this.tag?.default) {
      this.systemSpecificTags.push(this.tag?.name);
    }
  }

  onDelete(event: any) {
    event.stopPropagation();

    if (this.isDeletable) {
      this.appDelete.emit(this.tag);
    }
  }
}
